import { generateEventId, urlify } from '../../utils/string';
import { deepClone } from '../../utils/object';
import { prefix } from '../../utils/locale';

const cartAnalytics = (product, selected, setup, originalProduct, currentCategory, selection = {}, fromList = '', remove = false, quantity = 1) => {
	const { currency } = setup.countries[setup.country];
	const uniqueEventID = generateEventId();
	if (!product && originalProduct) {
		// Create product in selection cache.
		product = {
			generatedClientSide: true,
			uri: originalProduct.uri,
			name: originalProduct.name,
			sku: originalProduct.sku,
			id: originalProduct.product,
			brand: originalProduct.brandName,
			canonicalUri: originalProduct.canonicalUri,
			image: originalProduct.media.slice(0, 2),
			categories: Object.keys(originalProduct.categories).reduce((acc, category) => ({ ...acc, [category]: { uri: originalProduct.categories[category].uri, name: originalProduct.categories[category].name } }), {}),
			localized: deepClone(originalProduct.localized),
			price: { ...originalProduct.markets[setup.market].pricesByPricelist[setup.pricelist] },
			sizes: Object.keys(originalProduct.items).map((size) => ({ name: originalProduct.items[size].name, item: size, stock: originalProduct.items[size].stockByMarket[setup.market] })),
			inStock: originalProduct.markets[setup.market].stockOfAllItems,
		};
	}

	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const itemCategory = currentCategory.split('/').reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
	const itemList = typeof fromList === 'string' ? fromList : (fromList[product.groupId] || '');

	if (remove) {
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				'x-fb-event_id': uniqueEventID,
				currency,
				items: [{
					item_name: product.name,
					item_id: selected,
					price: product.price.priceAsNumber,
					currency,
					item_brand: product.brandName,
					...itemCategory,
					item_list_id: urlify(itemList),
					item_list_name: itemList,
					item_variant: product.variantName,
					quantity: `${quantity}`,
				}],
			},
		});
		return;
	}

	window.dataLayer.push({
		event: 'AddToCart',
		event_id: uniqueEventID,
		values: {
			value: product.price.priceAsNumber,
			currency,
			content_name: product.name,
			content_type: 'product',
			content_ids: [selected],
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'AddToCartGA',
		ecommerce: {
			currencyCode: currency,
			add: {
				products: [{
					name: product.name,
					id: selected,
					price: product.price.priceAsNumber,
					brand: product.brandName,
					category: currentCategory,
					variant: product.variantName,
					quantity,
				}],
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency,
			items: [{
				item_name: product.name,
				item_id: selected,
				price: product.price.priceAsNumber,
				currency,
				item_brand: product.brandName,
				...itemCategory,
				item_list_id: urlify(itemList),
				item_list_name: itemList,
				item_variant: product.variantName,
				quantity: `${quantity}`,
			}],
		},
	});

	if (typeof window._learnq === 'undefined') window._learnq = []; // eslint-disable-line no-underscore-dangle
	window._learnq.push(['track', 'Added to Cart', { // eslint-disable-line no-underscore-dangle
		$value: selection.totals.grandTotalPriceAsNumber,
		AddedItemProductName: product.name,
		AddedItemProductID: selected,
		AddedItemSKU: product.sku,
		AddedItemCategories: product.canonicalUri.split('/').slice(0, -1),
		AddedItemImageURL: product.image?.[0] || '',
		AddedItemURL: `${window.location.origin}${prefix(setup, product.canonicalUri)}`,
		AddedItemPrice: product.price.priceAsNumber,
		AddedItemQuantity: 1,
		ItemNames: selection.items.map((i) => i.product?.name),
		CheckoutURL: `${window.location.origin}${prefix(setup, 'selection')}`,
		Items: selection.items.map((i) => ({
			ProductID: i.item,
			SKU: i?.product?.sku,
			ProductName: i?.product?.name,
			Quantity: i.quantity,
			ItemPrice: i.priceEachAsNumber,
			RowTotal: i.totalPriceAsNumber,
			ProductURL: `${window.location.origin}${prefix(setup, i?.product?.categoryUri)}/${i?.product?.uri}`,
			ImageURL: i?.product?.media?.standard?.[0],
			ProductCategories: (i?.product?.categoryUri || '').split('/'),
		})),
	}]);
};

export default cartAnalytics;
